import React from 'react'

const BellIcon = () => {
	return (
		<svg width={21} height={27} viewBox='0 0 21 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M12.87 24.2a2.757 2.757 0 00-.11-.66H7.81a2.75 2.75 0 00-.11.66 2.525 2.525 0 002.53 2.53 2.485 2.485 0 002.64-2.53zM20.68 20.13a.764.764 0 00-.275-.55s-2.2-2.42-2.2-8.69c0-4.895-3.3-6.93-5.995-7.59V1.87a1.87 1.87 0 10-3.74 0V3.3c-2.695.605-5.995 2.64-5.995 7.59 0 6.27-2.2 8.69-2.2 8.69a1.292 1.292 0 00-.275.55v1.705h20.68V20.13z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default BellIcon
